(ns ductile.ui.entity
  (:require [ductile.ui.fahrzeug :as fahrzeug]))


(defn entity-view [entity]
  (fahrzeug/entity-view (select-keys entity [:ductile/id]) entity))

(defn entity-page [result _match]
  (entity-view result))
